module.exports = __webpack_public_path__ + "static/6314-c7fe6c4992616aba088ce8a6fd6b424f.png";